<template>
    <div style="display: flex; justify-content: space-between; align-items: center; padding: 15px 20px">
        <h4 style="margin-bottom: 0;">Danh sách học viên phát hành hoá đơn thuế</h4>
        <div class="">
            <el-button
                :loading="isExporting"
                class="text-white"
                style="border: none"
                type="primary"
                @click="exportStudentInvoice"
            >
                <i class="el-icon-download text-white"></i>
                <span v-if="!isExporting">Export</span>
                <span v-else>{{ percent }}%</span>
            </el-button>
        </div>
    </div>
</template>

<script>
import {exportExcel} from "../../../../core/filters";
import {STUDENT_TAX_INVOICE} from "../../../../core/services/store/tax-invoice/tax-invoice.module";
import StudentTaxInvoiceModel from "../model/StudentTaxInvoiceModel";

export default {
    components: {},
    data() {
        return {
            is_export_excel: false,
            isImport: false,
            isError: false,
            isExporting: false,
            percent: 0,
        }
    },
    methods: {
        handleCloseDialog() {
            this.isImport = false
        },
        getListTaxInvoice() {
            this.$emit('getListTaxInvoice')
        },
        mapExportRow(item) {
            return {
                user_id: item.user_id,
                ten_khach_hang: item.ten_khach_hang,
                so_dien_thoai: item.so_dien_thoai,
                trang_thai_text: item.trang_thai_text,
                tong_gia_khoa: item.tong_gia_khoa,
                tong_so_tien_dong: item.tong_so_tien_dong,
                trung_tam: item.trung_tam,
                contract_id: item.contract_id,
                invoiced_at: item.invoiced_at,
                khoa_hoc_1: item.khoa_hoc_1,
                khoa_hoc_2: item.khoa_hoc_2,
                khoa_hoc_3: item.khoa_hoc_3,
                khoa_hoc_4: item.khoa_hoc_4,
                khoa_hoc_5: item.khoa_hoc_5,
                ten_nguoi_chuyen_nhuong: item.ten_nguoi_chuyen_nhuong,
                so_dien_thoai_nguoi_chuyen_nhuong: item.so_dien_thoai_nguoi_chuyen_nhuong,
            }
        },

        async exportStudentInvoice() {
            const HEADER_ROW_EXPORT_STUDENT_TAX_INVOICE = [
                {
                    key: 'user_id',
                    value: 'Mã học viên',
                },
                {
                    key: 'ten_khach_hang',
                    value: 'Tên khách hàng',
                },
                {
                    key: 'so_dien_thoai',
                    value: 'Số điện thoại',
                },
                {
                    key: 'trang_thai_text',
                    value: 'Trạng thái',
                },
                {
                    key: 'tong_gia_khoa',
                    value: 'Tổng giá khoá',
                },
                {
                    key: 'tong_so_tien_dong',
                    value: 'Tổng số tiền nạp rút',
                },
                {
                    key: 'trung_tam',
                    value: 'Trung tâm',
                },
                {
                    key: 'contract_id',
                    value: 'Mã hợp đồng',
                },
                {
                    key: 'invoiced_at',
                    value: 'Ngày phát hành',
                },
                {
                    key: 'khoa_hoc_1',
                    value: 'Khoá học 1',
                },
                {
                    key: 'khoa_hoc_2',
                    value: 'Khoá học 2',
                },
                {
                    key: 'khoa_hoc_3',
                    value: 'Khoá học 3',
                },
                {
                    key: 'khoa_hoc_4',
                    value: 'Khoá học 4',
                },
                {
                    key: 'khoa_hoc_5',
                    value: 'Khoá học 5',
                },
                {
                    key: 'ten_nguoi_chuyen_nhuong',
                    value: 'Tên người chuyển nhượng',
                },
                {
                    key: 'so_dien_thoai_nguoi_chuyen_nhuong',
                    value: 'Số điện thoại người chuyển nhượng',
                },
            ]

            const basePayload = {
                keyword: this.$route.query?.keyword ?? null,
                phone: this.$route.query?.phone ?? null,
                center_id: this.$route.query?.center_id ?? null,
                year: this.$route.query?.year ?? null,
                per_page: 1000,
            }

            this.isExporting = true
            this.is_export_excel = true
            try {
                const firstRes = await this.$store.dispatch(STUDENT_TAX_INVOICE, {...basePayload, page: 1})
                if (firstRes.error) {
                    this.$bvToast.toast(firstRes?.data?.message || 'Export thất bại', {
                        title: 'Export excel',
                        variant: 'danger',
                        solid: true
                    });
                    return
                }

                const firstPage = firstRes?.data || {}
                const totalPages = Number(firstPage.last_page || 1)
                let exportRows = (firstPage.data || []).map((item) =>
                    this.mapExportRow(new StudentTaxInvoiceModel(item))
                )
                this.percent = totalPages > 0 ? Math.round((1 / totalPages) * 100) : 0

                for (let page = 2; page <= totalPages; page++) {
                    const pageRes = await this.$store.dispatch(STUDENT_TAX_INVOICE, {...basePayload, page})
                    if (pageRes.error) {
                        continue
                    }
                    const pageRows = (pageRes?.data?.data || []).map((item) =>
                        this.mapExportRow(new StudentTaxInvoiceModel(item))
                    )
                    exportRows = [...exportRows, ...pageRows]
                    this.percent = Math.min(100, Math.round((page / totalPages) * 100))
                }
                console.log(exportRows);
                this.percent = 100
                exportExcel(
                    HEADER_ROW_EXPORT_STUDENT_TAX_INVOICE,
                    exportRows,
                    "Danh sách học viên phát hành hoá đơn thuế.xlsx",
                    false
                )
            } catch (e) {
                this.$bvToast.toast('Export thất bại', {
                    title: 'Export excel',
                    variant: 'danger',
                    solid: true
                });
                console.log(e, 'error')
            } finally {
                this.isExporting = false
                this.is_export_excel = false
                setTimeout(() => {
                    this.percent = 0
                }, 500)
            }
        },
    },
}
</script>

<style scoped>

</style>